module.exports = __webpack_public_path__ + "img/icon_red_pn.4cc7f320.png";